// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__9H14Q","rights":"Footer_rights__tHgt3"};